/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ creator: NonNullable<unknown> }} Agent_Access_Hidden_KnowledgeInputs */



/**
* | output |
* | --- |
* | "1 space you can't see: ask {creator}." |
*
* @param {Agent_Access_Hidden_KnowledgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_hidden_knowledge = /** @type {((inputs: Agent_Access_Hidden_KnowledgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Hidden_KnowledgeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`1 Bereich, den Sie nicht sehen können: Fragen Sie ${i?.creator}.`)
	return /** @type {LocalizedString} */ (`1 space you can't see: ask ${i?.creator}.`)
});